import React from 'react';
import * as properties from '../../elementsPropertiesItems';
import { isSet } from '../../../../Utils/CommonFunctions';
// import elementsProperties from './elementsProperties';


const Link = (props)=>{
    const {elementData} = props;
    let linkValue = (isSet(elementData.attributes.href,null)!==null)?elementData.attributes.href:'#';
    let linkTargetValue = (isSet(elementData.attributes.target,null)!==null)?elementData.attributes.target:'#';
    const changeHandler = (e,getAttr) => {
        const {value} = e.target;        
        //props.changeHandler(path,keyParam,value)   
        if(getAttr==='target'){
            props.changeHandler('.attributes','target',value);
        }else{
            props.changeHandler('.attributes','href',value);     
        }        
    }  

    return(
        <div className="w-100">
            <div className="input-group mb-3">  
                <div className="input-group-prepend">
                    <span className="input-group-text text-truncate" style={{minWidth:'100px'}}>Href</span>
                </div>              
                <input type="text" className="form-control" value={linkValue} onChange={e=>changeHandler(e,'href')} />                
            </div>
            <div className="input-group mb-3">  
                <div className="input-group-prepend">
                    <span className="input-group-text text-truncate" style={{minWidth:'100px'}}>Target</span>
                </div> 
                <select className="form-control input-border-bottom1" onChange={e=>changeHandler(e,'target')}> 
                    {
                        properties.LinkTargetTypes.map((item,ind)=>{
                            let isSelected = '';
                            if(item.value === linkTargetValue){
                               isSelected = 'selected';
                            }
                            return(
                                <option selected={isSelected} value={item.value}> {item.label} </option>    
                            )
                        })
                    }                    
                </select>             
                               
            </div>             
        </div>
    )
}


export default Link;